/**
 * Created by mukund on 6/22/16.
 */

'use strict';

angular.module('mediacloudApp')
    .factory('ProfileService', function($resource){
        return $resource('api/profile');
    });
